import api from "./axiosInstance";

export const bulkCreateSystemValues = async (endpoint, names, buildBody) => {
  const created = [];
  const failed = [];

  for (const name of names) {
    try {
      const body = buildBody ? buildBody(name) : { name, active_flag: true };
      const res = await api.post(endpoint, body);
      created.push(res.data.data);
    } catch (err) {
      failed.push(name);
    }
  }

  return { created, failed };
};
